import { rei } from "@/services/api"

class CausaMorteService {
  static getCausaMorte (params = null) {
    if (params == null) {
      return rei.get(`causa-morte`).then(res => res.data)
    } else {
      let query = []
      query.push(params.perPage ? 'perPage=' + params.perPage : '')
      query.push(params.page ? 'page=' + params.page : '')
      query.push(params.descricao ? 'descricao=' + params.descricao : '')
      query.push(params.cartorio_id ? 'cartorio_id=' + params.cartorio_id : '')
      return rei.get(`causa-morte?${query.join('&')}`).then(res => res.data)
    }
  }

  static saveCausaMorte (causa) {
    return rei.post(`causa-morte`, causa).then(res => res.data)
  }

  static updateCausaMorte (causa, id) {
    return rei.put(`causa-morte/${id}`, causa).then(res => res.data)
  }

  static excludeCausaMorte (id) {
    return rei.delete(`causa-morte/${id}`)
  }
}

export default CausaMorteService
